import React from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import LogoutButton from "@/components/Auth/LogoutButton";
import { useAuth } from "@/context/auth";

const AppTopbar: React.FC = () => {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b bg-background/95 backdrop-blur-sm px-4">
      <div className="flex items-center gap-2">
        <SidebarTrigger />
      </div>
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground hidden sm:inline">
          {user?.first_name || user?.email}
        </span>
        <LogoutButton variant="ghost" className="text-sm" />
      </div>
    </header>
  );
};

export default AppTopbar;
